module.exports = __webpack_public_path__ + "img/chatbot4.46e3ee43.svg";